import n from '../../../../../../../../external/rollup-plugin-styles/dist/runtime/inject-css.js';
var css = ".side-by-side-editor-container{height:100%;width:100%}";
n(css,{});
export { css, css as default };
